import React, { useState, useEffect } from "react";
import "./Account.css"; // Make sure to add relevant styles in the CSS file
import axios from "axios";
import { faAdd, faChevronDown, faChevronUp, faPencil, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { confirmDelete } from "../../../../helpers/PromptUtils";
import { getToken } from "../../../../helpers/Jwt";
import { formatCurrency } from "../../../../helpers/CurrencyInput";

const Account = () => {
    const navigate = useNavigate();

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_ACCOUNT = "api/erpppsu/account";

    const [expandedAccounts, setExpandedAccounts] = useState({});

    const fetchData = async (URL) => {
        try {
            const response = await axios.get(URL);
            return response.data;
        } catch (err) {
            setError("Failed to fetch data. Please try again later.");
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const groupAccountsByParent = (accounts) => {
        const grouped = {};

        accounts.forEach((account) => {
            if (account.parent_account === null) {
                grouped[account.code] = {
                    ...account,
                    subAccounts: [],
                };
            } else {
                // If the account is a sub-account
                if (!grouped[account.parent_account]) {
                    grouped[account.parent_account] = {
                        subAccounts: [],
                    };
                }
                grouped[account.parent_account].subAccounts.push(account);
            }
        });

        // Return grouped accounts, including parent accounts and their sub-accounts
        return Object.values(grouped);
    };

    // Handle expansion toggle
    const toggleExpand = (parentCode) => {
        setExpandedAccounts((prevState) => ({
            ...prevState,
            [parentCode]: !prevState[parentCode],
        }));
    };

    const renderAccountRow = (account) => {
        const handleAction = (rowData, callback) => {
            callback(rowData);
        };



        const actionParent = [
            {
                className: 'edit-btn',
                icon: <FontAwesomeIcon icon={faPencil} />,
                text: ' Ubah',
                callback: handleEdit,
            },
        ];

        const actionChildren = [
            {
                className: 'delete-btn',
                icon: <FontAwesomeIcon icon={faTrash} />,
                text: ' Hapus',
                callback: handleRemove,
            },
            {
                className: 'edit-btn',
                icon: <FontAwesomeIcon icon={faPencil} />,
                text: ' Ubah',
                callback: handleEdit,
            },
        ];

        return (
            <React.Fragment key={account.id}>
                <tr className="parent-account-row">
                    <td>{account.code}</td>
                    <td>{account.name}</td>
                    <td>{account.category}</td>
                    <td>{formatCurrency(account.current_balance, 'IDR')}</td>
                    {/* <td>{account.subAccounts && account.subAccounts.length > 0 ? "-" : formatCurrency(account.current_balance, 'IDR')}</td> */}
                    <td>
                        <div className="action-buttons">
                            {actionParent.map((action, index) => {
                                return (
                                    <button
                                        key={index}
                                        onClick={() => handleAction(account, action.callback)}
                                        className={`m-1 action-btn ${action.className}`}
                                    >
                                        {action.icon}
                                        {action.text}
                                    </button>
                                );
                            })}
                        </div>
                    </td>
                </tr>

                {/* Toggle button for parent account */}
                {account.subAccounts && account.subAccounts.length > 0 && (
                    <tr className="expand-row">
                        <td colSpan="5">
                            <button
                                onClick={() => toggleExpand(account.code)}
                                className="expand-btn"
                            >
                                <FontAwesomeIcon icon={expandedAccounts[account.code] ? faChevronUp : faChevronDown} />
                                {expandedAccounts[account.code] ? " Sembunyikan" : " Tampilkan"} Sub-Akun
                            </button>
                        </td>
                    </tr>
                )}

                {/* Render sub-accounts if expanded */}
                {expandedAccounts[account.code] && account.subAccounts && account.subAccounts.map((subAccount) => (
                    <tr key={subAccount.id} className="sub-account-row">
                        <td><p className="text-center">{subAccount.code}</p></td>
                        <td>{subAccount.name}</td>
                        <td>{subAccount.category}</td>
                        <td>{formatCurrency(subAccount.current_balance, 'IDR')}</td>
                        <td>
                            <div className="action-buttons">
                                {actionChildren.map((action, index) => {
                                    return (
                                        <button
                                            key={index}
                                            onClick={() => handleAction(subAccount, action.callback)}
                                            className={`m-1 action-btn ${action.className}`}
                                        >
                                            {action.icon}
                                            {action.text}
                                        </button>
                                    );
                                })}
                            </div>
                        </td>
                    </tr>
                ))}
            </React.Fragment>
        );
    };

    useEffect(() => {
        fetchData(`${BASE_URL}${PATH_ACCOUNT}`).then((accounts) => {
            if (accounts) {
                const groupedAccounts = groupAccountsByParent(accounts);
                setData(groupedAccounts);
            }
        });
    }, []);

    const handleEdit = (rowData) => {
        navigate(`/activity-erpppsu/edit-account/${rowData.id}`);
    };

    const handleRemove = (rowData) => {
        const confirmed = confirmDelete('Are you sure you want to delete this account?');
        if (confirmed) {
            axios({
                method: 'DELETE',
                url: `${BASE_URL}${PATH_ACCOUNT}?id=${rowData.id}`,
                headers: {
                    'Content-Type': 'x-www-form-urlencoded',
                    'Authorization': `Bearer ${getToken()}`
                },
            }).then(function (response) {
                window.location.reload();
            });
        }
    }

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div>
            <div className='flex items-center justify-between'>
                <h1>Kas & Bank</h1>

                <div className='flex items-center'>
                    <div className="add-account-btn mx-2">
                        <button
                            onClick={() => navigate('/activity-erpppsu/journal/new')}
                            className="btn btn-primary"
                        >
                            <FontAwesomeIcon icon={faAdd} color="white" /> Buat Jurnal Umum
                        </button>
                    </div>
                    <div className="add-account-btn">
                        <button
                            onClick={() => navigate('/activity-erpppsu/add-account')}
                            className="btn btn-primary"
                        >
                            <FontAwesomeIcon icon={faAdd} color="white" /> Buat Akun Baru
                        </button>
                    </div>
                </div>
            </div>

            <div className="relative overflow-x-auto">
                <table className="account-table min-w-full bg-white border border-gray-200 p-2">
                    <thead>
                        <tr>
                            <th className="text-gray-500 font-medium text-xs uppercase">Kode Akun</th>
                            <th className="text-gray-500 font-medium text-xs uppercase">Nama Akun</th>
                            <th className="text-gray-500 font-medium text-xs uppercase">Kategori Akun</th>
                            <th className="text-gray-500 font-medium text-xs uppercase">Saldo</th>
                            <th className="text-gray-500 font-medium text-xs uppercase">Aksi</th>
                        </tr>
                    </thead>
                    <tbody className="text-sm">
                        {data.map((account) => renderAccountRow(account))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Account;
